import { ComponentLoader } from '@bythepixel/component-loader';
import LargeMap from './largeMap';
import LocationCard from './largeMap/locationCard';
import Filterable from './locationSearch/filterable';
import FilterInput from './locationSearch/filterInput';

window.largeMap = new ComponentLoader(document, [
  LargeMap,
  Filterable,
  FilterInput,
],
() => {
  const map = window.largeMap.getRegistry().entries().next().value[1].instance;
  window.locationCards = new ComponentLoader(document, [
    [
      LocationCard,
      {
        map,
        activeClass: 'location-listing--active',
      },
    ],
  ],
  () => {
    map.fitBounds();
    setTimeout(() => {
      map.fitBounds();
    }, 1000);
  });
});
